export default "__VITE_ASSET__CQtJKrJM__";